export default __webpack_public_path__ + "island3.e6c4495423038fe4437cf91723f64fcb.png";